/**
 * Hooks
 */
export const TOGGLE_AFTER = new Event("toggleAfter"),
	TOGGLE_BEFORE = new Event("toggleBefore");
